import * as angular from "angular";

export class OrganisationService {
    private apiRoot: string;
    private $http: any;

    private restlerRoot: string;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = "/v2/organisation";
        this.restlerRoot = __env.apiUrl() + "/organisation";
    }

    /**
     * AV-18115: the accounts under one organisation, for the drill-in the
     * admin organisations list opens from its Accounts count.
     */
    adminCampaigns(oid: number): Promise<object> {
        return this.$http.get(this.apiRoot + "/admin/" + oid + "/campaigns");
    }

    adminUsers(oid: number): Promise<object> {
        return this.$http.get(this.restlerRoot + "/admin_users/" + oid);
    }

    all(): Promise<object> {
        return this.$http.get(this.apiRoot + "/all");
    }

    removeUser(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/remove_user/" + data.uid, data);
    }

    adminRemoveUser(data: any): Promise<object> {
        return this.$http.post(
            this.apiRoot + "/admin_remove_user/" + data.uid,
            data
        );
    }

    adminBulkRemoveUser(oids: number[], uid: number | string): Promise<object> {
        return this.$http.post("/v2/organisation/admin_bulk_remove_user", {
            oids: oids,
            uid: uid,
        });
    }

    addAdmin(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/add_admin", data);
    }

    admin(data?: any, timeout?: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/admin", {
            params: data,
            timeout: timeout,
        });
    }

    /** Quick-filter chip counts for the admin list, fetched apart from the rows. */
    adminChipCounts(data?: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/admin_chip_counts", {
            params: data,
        });
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/create", data);
    }

    updateUser(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/updateUser", data);
    }

    users(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/users", data);
    }

    mapUsers(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/map_users", data);
    }

    headlineStats(data: any): Promise<object> {
        return this.$http.get(
            this.apiRoot + "/headline_stats/" + data.oid,
            data
        );
    }

    userHeadlineStats(): Promise<object> {
        return this.$http.get(this.apiRoot + "/user_headline_stats");
    }

    limits(data: any): Promise<object> {
        return this.$http.get("/v2/organisationlimit/" + data.id, data);
    }

    updateCampaignLimits(data: any): Promise<object> {
        return this.$http.post(
            "/v2/organisationlimit/updateCampaignLimits",
            data
        );
    }

    cancel(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/cancel/" + data.oid, data);
    }

    reactivate(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/reactivate/" + data.oid, data);
    }

    pause(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/pause/" + data.oid, data);
    }
    update(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/updateName/" + data.oid, data);
    }

    adminUpdate(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/update/" + data.oid, data);
    }

    stats(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/stats", { params: data });
    }

    canvassStats(params: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/canvass/stats", {
            params: params,
        });
    }

    userCustomFields(data?: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/userCustomFields", data);
    }
}

angular
    .module("vcServices")
    .service("OrganisationService", OrganisationService);
